export default {
  "hierarchy": {
    "dashboard": [
      "checkbox-dashboard"
    ],
    "agreementsCheckbox": [
      "checkbox-agreementsCheckbox"
    ],
    "none": [
      "checkbox-none"
    ],
    "targetRsrc": [
      "checkbox-targetRsrc"
    ],
    "locatorReplacement": [
      "checkbox-locatorReplacement"
    ],
    "null": [
      "checkbox-null"
    ],
    "multiSelector": [
      "checkbox-multiSelector"
    ]
  },
  "props": {
    "default": {
      "iconOn": "fa fa-check",
      "helpVariant": "",
      "labelVariant": "checkboxLabel"
    },
    "dashboard": {
      "iconOn": "fa fa-circle",
      "helpVariant": "",
      "labelVariant": "checkboxLabel",
      "variants": null
    },
    "agreementsCheckbox": {
      "iconOn": "fa fa-check",
      "helpVariant": "",
      "labelVariant": "checkboxLabelWrap"
    },
    "none": {
      "iconOn": "fa fa-check",
      "helpVariant": "",
      "labelVariant": "checkboxLabel",
      "variants": null
    },
    "targetRsrc": {
      "iconOn": "fa fa-check",
      "helpVariant": "",
      "labelVariant": "checkboxLabel",
      "variants": null
    },
    "locatorReplacement": {
      "iconOn": "fa fa-check",
      "helpVariant": "",
      "labelVariant": "locatorReplacement"
    },
    "null": {
      "iconOn": "null",
      "helpVariant": "",
      "labelVariant": "checkboxLabel",
      "iconOff": "null"
    },
    "multiSelector": {
      "iconOn": "fa fa-check",
      "helpVariant": "",
      "labelVariant": "checkboxLabel",
      "variants": null
    }
  }
}